import { SUPPLIER_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { ISupplier } from "../../shared/interfaces/supplier/ISupplier";

export const SupplierService = {
  getAll: (params: IPagination) => requests.get(SUPPLIER_URL, params),
  create: (params: ISupplier) => requests.post(`${SUPPLIER_URL}`, params),
  getSingle: (id: number) => requests.get(`${SUPPLIER_URL}/${id}`),
  update: (params: ISupplier, id: number) =>
    requests.put(`${SUPPLIER_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${SUPPLIER_URL}/${id}`),
};
